// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7a27b6a3625ef8785cda","655":"93ff833eaea66341660c"}[chunkId] + ".js";
};